import { useState } from 'react';
import { hotTags, topicPosts } from '@/mocks/homeContent';

const avatarTone = [
  'bg-primary-100 text-primary-800',
  'bg-accent-100 text-accent-900',
  'bg-secondary-200 text-secondary-900',
];

const chips = ['全部讨论', '站内公告', '录音疑云', '板块答疑'];

export default function TopicFeed() {
  const [active, setActive] = useState('全部讨论');
  return (
    <section id="专题话题" className="bg-background-100">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className="ri-chat-smile-3-line flex h-5 w-5 items-center justify-center" />
              </span>
              <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">专题话题</h2>
              <span className="rounded-full bg-secondary-200 px-2.5 py-1 text-xs font-bold text-secondary-900">站内讨论</span>
            </div>
            <p className="mt-2 text-sm text-foreground-600">每一场热议都在这里继续，跟帖要理性，观点要留证据</p>
          </div>
          <div className="hidden items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-500 ring-1 ring-background-200 md:flex">
            <i className="ri-team-line flex h-4 w-4 items-center justify-center" />今日在线 2,840 人
          </div>
        </div>

        <div className="grid gap-5 lg:grid-cols-[330px_1fr]">
          {/* composer + tag cloud */}
          <div className="space-y-4">
            <div className="rounded-xl bg-background-50 p-4 ring-1 ring-background-200">
              <p className="flex items-center gap-2 text-sm font-bold text-foreground-900">
                <i className="ri-quill-pen-line flex h-4 w-4 items-center justify-center text-primary-600" />发起一条讨论
              </p>
              <div className="mt-3 rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-400 ring-1 ring-background-200">
                说说你对这场热点的看法……
              </div>
              <div className="mt-2 flex flex-wrap items-center justify-between gap-2">
                <span className="text-[11px] text-foreground-400">理性吃瓜 · 附上来源更好</span>
                <span className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-1.5 text-xs font-bold text-background-50">发布话题</span>
              </div>
            </div>

            <div className="rounded-xl bg-background-50 p-4 ring-1 ring-background-200">
              <p className="mb-3 flex items-center gap-2 text-sm font-bold text-foreground-900">
                <i className="ri-price-tag-3-line flex h-4 w-4 items-center justify-center text-accent-600" />热议标签
              </p>
              <div className="flex flex-wrap gap-2">
                {hotTags.map((t) => (
                  <a
                    key={t.name}
                    href="#专题话题"
                    className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-background-100 px-3 py-1.5 text-xs font-bold text-foreground-700 ring-1 ring-background-200 transition hover:bg-accent-100 hover:text-accent-900 hover:ring-accent-200"
                  >
                    {t.name}
                    <span className="font-label text-[11px] text-foreground-400">{t.num}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* posts list */}
          <div>
            <div className="mb-4 flex gap-2 overflow-x-auto rounded-full bg-background-200 p-1 sm:inline-flex">
              {chips.map((c) => (
                <button
                  key={c}
                  type="button"
                  onClick={() => setActive(c)}
                  className={`whitespace-nowrap rounded-full px-4 py-1.5 text-xs font-bold transition ${
                    active === c ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-foreground-900'
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>

            <div className="space-y-3">
              {topicPosts.map((p, i) => (
                <article key={i} className="group rounded-xl bg-background-50 p-4 ring-1 ring-background-200 transition hover:ring-accent-300 md:p-5">
                  <div className="flex items-start gap-3">
                    <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-heading text-sm font-bold ${avatarTone[i % avatarTone.length]}`}>
                      {p.letter}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="text-sm font-bold text-foreground-900">{p.author}</span>
                        <span className="whitespace-nowrap rounded-sm bg-secondary-100 px-1.5 py-0.5 text-[10px] font-bold text-secondary-800">{p.role}</span>
                        <span className="ml-auto text-[11px] text-foreground-400">{p.time}</span>
                      </div>
                      <h3 className="mt-1.5 cursor-pointer font-heading text-base font-bold text-foreground-950 transition group-hover:text-primary-700 md:text-lg">
                        {p.title}
                      </h3>
                      <p className="mt-1.5 line-clamp-2 text-sm leading-6 text-foreground-600">{p.excerpt}</p>
                      <div className="mt-3 flex flex-wrap items-center gap-2">
                        {p.tags.map((t) => (
                          <span key={t} className="whitespace-nowrap rounded-sm bg-background-100 px-2 py-0.5 text-[11px] font-bold text-foreground-600 ring-1 ring-background-200">
                            #{t}
                          </span>
                        ))}
                      </div>
                      <div className="mt-3 flex items-center gap-4 border-t border-background-100 pt-3 text-xs text-foreground-500">
                        <span className="flex cursor-pointer items-center gap-1 transition hover:text-primary-600">
                          <i className="ri-chat-4-line flex h-4 w-4 items-center justify-center" />讨论 {p.replies}
                        </span>
                        <span className="flex cursor-pointer items-center gap-1 transition hover:text-primary-600">
                          <i className="ri-thumb-up-line flex h-4 w-4 items-center justify-center" />赞同 {p.likes}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line flex h-4 w-4 items-center justify-center" />围观 {Math.round(p.replies * 13)}
                        </span>
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>

            <div className="mt-4 flex justify-center">
              <a href="#专题话题" className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-background-50 px-5 py-2 text-sm font-bold text-foreground-700 ring-1 ring-background-200 transition hover:bg-secondary-100">
                查看更多讨论 <i className="ri-arrow-down-line flex h-4 w-4 items-center justify-center" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}